import ArticleDetailsTab from "./ArticleDetailsTab";
import ArticleHistoryTable from "./ArticleHistoryTable";
import ArticleDetailsCard from "./ArticleDetailsCard";

const ArticleModal = ({ articleId, type }) => {
  if (type === "articleHistory") {
    return <ArticleHistoryTable articleId={articleId} />;
  }

  if (type === "articleDetails") {
    const tabNames = [
      { label: "Details", key: "1" },
      { label: "Files", key: "2" },
    ];

    return (
      <>
        <ArticleDetailsTab tabNames={tabNames} articleId={articleId}/>
        
      </>
    );
  }

  return null; // اگر مقدار نامعتبری باشد، هیچ چیزی نمایش داده نشود
};

export default ArticleModal;
